module.exports = __webpack_public_path__ + "static/ebapp-3-5600cb3759deeefabbe0aa5c475ecc94.jpg";